import React, { useEffect, useState } from 'react'
import { Button, Card, Form, InputNumber, message } from 'antd'
import { get, patch } from '../lib/request'
import { ConfigItem, errMsg } from '../lib/api'
import { useAuthStore } from '../stores/auth'
import { hasPermission } from '../utils/permissions'

/**
 * 保护期配置（configs.protection_days，默认 90 天）
 * 复用于 RiskControl 与 SystemConfig；仅 admin/super_admin 可改
 */
const ProtectionConfig: React.FC = () => {
  const role = useAuthStore((s) => s.user?.role)
  const canEdit = hasPermission(role, 'CONFIG_EDIT')
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [form] = Form.useForm<{ protection_days: number; follow_up_timeout_hours: number }>()

  useEffect(() => {
    get<ConfigItem[]>('/admin/configs')
      .then((items) => {
        const map = new Map(items.map((c) => [c.key, c.value]))
        form.setFieldsValue({
          protection_days: Number(map.get('protection_days') ?? 90),
          follow_up_timeout_hours: Number(map.get('follow_up_timeout_hours') ?? 24),
        })
      })
      .catch((err) => message.warning(errMsg(err, '配置加载失败')))
      .finally(() => setLoading(false))
  }, [form])

  const save = async () => {
    const v = await form.validateFields()
    setSaving(true)
    try {
      await patch('/admin/configs', {
        protection_days: v.protection_days,
        follow_up_timeout_hours: v.follow_up_timeout_hours,
      })
      message.success('配置已保存（新归属线索立即按新保护期生效）')
    } catch (err: unknown) {
      message.error(errMsg(err, '保存失败'))
    } finally {
      setSaving(false)
    }
  }

  return (
    <Card title="归因保护期配置" style={{ borderRadius: 12, maxWidth: 560 }} loading={loading}>
      <Form form={form} layout="vertical" disabled={!canEdit}>
        <Form.Item
          name="protection_days"
          label="归因保护期（天）"
          rules={[{ required: true, message: '请输入保护期天数' }]}
          extra="归因时快照到线索；到期后自动释放归属。默认 90 天。"
        >
          <InputNumber min={1} max={365} style={{ width: '100%', minHeight: 44 }} />
        </Form.Item>
        <Form.Item
          name="follow_up_timeout_hours"
          label="未跟进超时释放（小时）"
          rules={[{ required: true, message: '请输入超时小时数' }]}
          extra="超过该时长未跟进的线索将释放入公海。默认 24 小时。"
        >
          <InputNumber min={1} max={720} style={{ width: '100%', minHeight: 44 }} />
        </Form.Item>
        {canEdit && (
          <Button type="primary" loading={saving} onClick={save} style={{ minHeight: 44 }}>
            保存配置
          </Button>
        )}
      </Form>
    </Card>
  )
}

export default ProtectionConfig
